import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl-next';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import LoadingButton from '@atlaskit/button/loading-button';
import DropdownMenu, { DropdownItem, DropdownItemGroup } from '@atlaskit/dropdown-menu';
import AtlassianIntelligenceIcon from '@atlaskit/icon/core/atlassian-intelligence';
import ChevronDown from '@atlaskit/icon/glyph/chevron-down';
import { fg } from '@atlaskit/platform-feature-flags';
import { Inline } from '@atlaskit/primitives';
import { messages } from './messages';
export const CreateFormDropdown = ({
  isLoading,
  onConvertForm,
  onCreateBlankForm,
  onCreateFormFromTemplate
}) => {
  const {
    createAnalyticsEvent
  } = useAnalyticsEvents();
  const {
    formatMessage
  } = useIntl();
  const handleOnCreateBlank = e => {
    onCreateBlankForm(e, createAnalyticsEvent({
      action: 'clicked',
      actionSubject: 'button'
    }));
  };
  return /*#__PURE__*/React.createElement(DropdownMenu, {
    placement: "bottom-end",
    shouldRenderToParent: true,
    trigger: ({
      triggerRef,
      ...props
    }) => /*#__PURE__*/React.createElement(LoadingButton, _extends({}, props, {
      appearance: "primary",
      iconAfter: /*#__PURE__*/React.createElement(ChevronDown, {
        label: ""
      }),
      ref: triggerRef,
      isLoading: isLoading
    }), /*#__PURE__*/React.createElement(FormattedMessage, messages.createFormTrigger))
  }, fg('shipit59_ai_forms_convertor') ? /*#__PURE__*/React.createElement(DropdownItemGroup, null, /*#__PURE__*/React.createElement(DropdownItem, {
    onClick: handleOnCreateBlank
  }, /*#__PURE__*/React.createElement(FormattedMessage, messages.createFormFromBlank)), /*#__PURE__*/React.createElement(DropdownItem, {
    onClick: onCreateFormFromTemplate
  }, /*#__PURE__*/React.createElement(FormattedMessage, messages.createFormTemplate)), /*#__PURE__*/React.createElement(DropdownItem, {
    onClick: onConvertForm
  }, /*#__PURE__*/React.createElement(Inline, {
    space: "space.075",
    alignBlock: "center"
  }, /*#__PURE__*/React.createElement(FormattedMessage, messages.createFromImport), /*#__PURE__*/React.createElement(AtlassianIntelligenceIcon, {
    color: "var(--ds-icon-brand, #0C66E4)",
    label: formatMessage(messages.atlassianIntelligenceLabel)
  })))) : /*#__PURE__*/React.createElement(DropdownItemGroup, null, /*#__PURE__*/React.createElement(DropdownItem, {
    onClick: onCreateFormFromTemplate
  }, /*#__PURE__*/React.createElement(FormattedMessage, messages.createFormTemplate)), /*#__PURE__*/React.createElement(DropdownItem, {
    onClick: handleOnCreateBlank
  }, /*#__PURE__*/React.createElement(FormattedMessage, messages.createFormBlank))));
};